import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import CreateDues from './CreateDues'
import EditDues from './EditDues'
import axiosInstance from '../../../hooks/axiosInstance'
import { toast } from 'react-toastify'
import Loader from "../../../components/utilities/Loader/Loader";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Pagination } from "@mui/material"

const DuesSetup = ({ isActive }) => {
    const [loading, setLoading] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)

    const [dues, setDues] = useState([])
    const [currentDue, setCurrentDue] = useState(null)

    const [createOpen, setCreateOpen] = useState(false)
    const [editOpen, setEditOpen] = useState(false)
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0)

    const [filter, setFilter] = useState({
        search: '', type: '', paginated: true
    })

    //  state for pagination
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [pageCount, setPageCount] = useState(1);
    //  pagination function
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleFilterChange = (e) => {
        const {name, value} = e.target

    setFilter(prevFilter => (
            {...prevFilter, [name]: value}
        ))
    }

    const refreshPage = () => {
        setRefreshKey(prevRefreshKey => prevRefreshKey + 1)
    }

    const fetchAssociationDues = () => {
        setLoading(true)
        axiosInstance.post(`/association/dues/fetch?page=${page}`, filter)
              .then(response => {
                setDues(response.data.data.data)
                const pageCount = Math.ceil(response.data.data.total / response.data.data.per_page);
                setPageCount(pageCount)
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setLoading(false))
    }

    const handleDelete = () => {
        setDeleteLoading(true)
        axiosInstance.delete(`/association/dues/${currentDue?.id}`)
              .then(res => {
                toast.success(res.data.message)
                setDeleteOpen(false)
                refreshPage()
              })
              .catch(err => {
                toast.error('An error occured. Please, try again')
              })
              .finally(() => setDeleteLoading(false))
    }


    useEffect(() => {
        if (isActive) {
            fetchAssociationDues()
        }
    }, [page, refreshKey, isActive])

  return (
    <>
        <div className="card" id="invoiceList">
            <div className="card-header border-0">
                <div className="d-flex align-items-center">
                    <h5 className="card-title mb-0 flex-grow-1">Dues Management</h5>
                    <div className="flex-shrink-0">
                        <div className="d-flex gap-2 flex-wrap">
                            <button className="btn btn-success" onClick={() => setCreateOpen(true)}>
                                <i className="ri-add-line align-bottom me-1"></i> Create Dues
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-body bg-light-subtle border border-dashed border-start-0 border-end-0">
                <form>
                    <div className="row g-3">
                        <div className="col-xxl-5 col-sm-12">
                            <div className="search-box">
                                <input 
                                    type="text" 
                                    className="form-control search bg-light border-light" 
                                    placeholder="Search ..." 
                                    name="search"
                                    value={filter.search}
                                    onChange={handleFilterChange}
                                />
                                <i className="ri-search-line search-icon"></i>
                            </div>
                        </div>
                        {/* <!--end col--> */}
                        <div className="col-xxl-3 col-sm-4">
                            <div className="input-light">
                                <select className="form-control" 
                                    name="type" 
                                    value={filter.type}
                                    onChange={handleFilterChange}
                                >
                                    <option value="" selected>All</option>
                                    <option value="recurrent">Recurrent</option>
                                    <option value="one_off">One Off</option>
                                </select>
                            </div>
                        </div>
                        {/* <!--end col--> */}

                        <div className="col-xxl-1 col-sm-4">
                            <button type="button" className="btn btn-primary w-100" onClick={fetchAssociationDues}>
                                <i className="ri-equalizer-fill me-1 align-bottom"></i> Filters
                            </button>
                        </div>
                        {/* <!--end col--> */}
                    </div>
                    {/* <!--end row--> */}
                </form>
            </div>
            <div className="card-body">
                {dues.length > 0 && (
                    <>
                        <div className="table-responsive table-card">
                            <table className="table align-middle table-nowrap" id="invoiceTable">
                                <thead className="text-muted">
                                    <tr>
                                        <th className="sort text-uppercase" data-sort="invoice_id">#</th>
                                        <th className="sort text-uppercase" data-sort="customer_name">Name</th>
                                        <th className="sort text-uppercase" data-sort="email">Type</th>
                                        <th className="sort text-uppercase" data-sort="country">Recurrence</th>
                                        <th className="sort text-uppercase" data-sort="invoice_amount">Amount</th>
                                        <th className="sort text-uppercase" data-sort="invoice_amount">Description</th>
                                        <th className="sort text-uppercase" data-sort="status">Status</th>
                                        <th className="sort text-uppercase" data-sort="action">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="list form-check-all" id="invoice-list-data">
                                    {
                                        dues.map((due, i) => (
                                            <tr key={due.id}>
                                                <td className="id">
                                                    {i + 1}
                                                </td>
                                                <td className="customer_name">
                                                    <div className="d-flex align-items-center">
                                                        {due.name}
                                                    </div>
                                                </td>
                                                <td className="email">
                                                    <span className={`badge ${due.type == 'recurrent' ? 'bg-dark' : 'bg-warning'} text-uppercase`}>
                                                        {due.type}
                                                    </span>
                                                </td>
                                                {due.type == 'recurrent'
                                                    ?
                                                    <td className="country">
                                                        <p className="mb-1"><b className="text-muted">Start Date:</b> {due.start_date}</p>
                                                        <p><b className="text-muted">End Date:</b> {due.end_date}</p>
                                                    </td>
                                                    :
                                                    <td>-</td>
                                                }
                                                <td className="invoice_amount">₦{Number(due.amount).toLocaleString()}</td>
                                                <td className="invoice_amount">{due.description}</td>
                                                <td className="status">
                                                    <span className={`badge ${due.status == 'active' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} text-uppercase`}
                                                    >{due.status}</span>
                                                </td>
                                                <td>
                                                    <div className="dropdown">
                                                        <button className="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i className="ri-more-fill align-middle"></i>
                                                        </button>
                                                        <ul className="dropdown-menu dropdown-menu-end">
                                                            {/* <li><button className="dropdown-item" href="javascript:void(0);" onclick="ViewInvoice(this);" data-id="25000351"><i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                                                                    View</button></li> */}
                                                            <li>
                                                                <button className="dropdown-item" onClick={() => {setCurrentDue(due); setEditOpen(true)}}>
                                                                    <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                                                                    Edit</button>
                                                            </li>
                                                            <li>
                                                                <a className="dropdown-item"
                                                                    onClick={() => {setCurrentDue(due); setDeleteOpen(true)}}
                                                                >
                                                                    <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                                                    Delete
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                            // <tr>
                                            //     <td className="id">
                                            //         2
                                            //     </td>
                                            //     <td className="customer_name">
                                            //         <div className="d-flex align-items-center">
                                            //             Conference Fee
                                            //         </div>
                                            //     </td>
                                            //     <td className="email">
                                            //         <span className="badge bg-warning text-dark text-uppercase">One Off</span>
                                            //     </td>
                                            //     <td className="country">-</td>
                                            //     <td className="invoice_amount">₦75,000</td>
                                            //     <td className="invoice_amount">Payment for warri conference and convention</td>
                                            //     <td className="status"><span className="badge bg-danger-subtle text-danger text-uppercase">Inactive</span>
                                            //     </td>
                                            //     <td>
                                            //         <div className="dropdown">
                                            //             <button className="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            //                 <i className="ri-more-fill align-middle"></i>
                                            //             </button>
                                            //             <ul className="dropdown-menu dropdown-menu-end">
                                            //                 <li><button className="dropdown-item" href="javascript:void(0);" onclick="ViewInvoice(this);" data-id="25000351"><i className="ri-eye-fill align-bottom me-2 text-muted"></i>
                                            //                         View</button></li>
                                            //                 <li><button className="dropdown-item" href="javascript:void(0);" onClick={() => setEditOpen(true)}><i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                                            //                         Edit</button></li>
                                            //                 <li>
                                            //                     <a className="dropdown-item remove-item-btn" data-bs-toggle="modal" href="#deleteOrder">
                                            //                         <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>
                                            //                         Delete
                                            //                     </a>
                                            //                 </li>
                                            //             </ul>
                                            //         </div>
                                            //     </td>
                                            // </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            <div className="noresult" style={{display: "none"}}>
                                <div className="text-center">
                                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#121331,secondary:#08a88a" style={{width: '75px', height:"75px"}}></lord-icon>
                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                    <p className="text-muted mb-0">We've searched more than 150+ invoices We did not find any invoices for you search.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                            <div className="col-sm-12 d-flex justify-content-end mt-4">
                                <Pagination
                                    onChange={handlePageChange}  
                                    count={pageCount} 
                                    color="primary" 
                                    shape="rounded"
                                    size="small"
                                    page={page}
                                />
                            </div>
                            {/* <!-- end col --> */}
                        </div>
                    </>
                )}

                {dues.length == 0 && (
                    <div className="noresult">
                        <div className="text-center">
                            <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c" style={{width:"75px",height:"75px"}}></lord-icon>
                            <h5 className="mt-2">Sorry! No Result Found</h5>
                            {/* <p className="text-muted mb-0">We've searched more than 150+ orders We did not find any orders for you search.</p> */}
                        </div>
                    </div>
                )}
            </div>
        </div>
        {loading && <Loader />}

        {/* Create Dues Modal */}
        <Modal
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={createOpen} onHide={() => setCreateOpen(false)}
        >
            <Modal.Header closeButton className='bg-light p-3'>
                <Modal.Title id="contained-modal-title-vcenter">
                    New Dues
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CreateDues refreshPage={refreshPage} close={() => setCreateOpen(false)}/>
            </Modal.Body>
        </Modal>


        {/* Edit Dues Modal */}
        <Modal
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={editOpen} onHide={() => setEditOpen(false)}
        >
            <Modal.Header closeButton className='bg-light p-3'>
                <Modal.Title id="contained-modal-title-vcenter">
                    Edit <b className='text-info'>{currentDue?.name}</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <EditDues currentDue={currentDue} refreshPage={refreshPage}s close={() => setEditOpen(false)}/>
            </Modal.Body>
        </Modal>

        {currentDue && (
          <>
            <Dialog
              open={deleteOpen}
              onClose={() => setDeleteOpen(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                    Delete <b className="text-primary">{currentDue?.name}</b> {" "} Due
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to perform this operation?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className="text-danger" onClick={() => setDeleteOpen(false)}>
                  Cancel
                </Button>
                <Button onClick={handleDelete} autoFocus>
                  Continue
                </Button>
              </DialogActions>
              {deleteLoading && <Loader />}
            </Dialog>
          </>
        )}
    </>
  )
}

export default DuesSetup
